// frontend/src/modules/admin/components/ParametresPlanning.jsx
import React, { useState, useEffect } from 'react';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const ParametresPlanning = () => {
  const [config, setConfig] = useState({
    // Fenêtre réservation
    jour_ouverture_resa: '1',
    heure_ouverture_resa: '00:00',
    jour_fermeture_nouvelle_resa: '4',
    heure_fermeture_nouvelle_resa: '23:59',
    jour_fermeture_modif_resa: '5',
    heure_fermeture_modif_resa: '12:00',
    
    // Option mercredi
    mercredi_vente_directe_actif: 'non',
    mercredi_heure_ouverture_matin: '09:00',
    mercredi_heure_fermeture_matin: '12:30',
    mercredi_heure_ouverture_aprem: '14:00',
    mercredi_heure_fermeture_aprem: '17:00',
    
    // Horaires retrait samedi
    samedi_heure_ouverture_matin: '09:00',
    samedi_heure_fermeture_matin: '12:30',
    samedi_heure_ouverture_aprem: '14:00',
    samedi_heure_fermeture_aprem: '17:00',
    
    // Gestion non retirées
    delai_rappel_non_retiree: '24',
    action_non_retiree: 'rappel'
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const joursOptions = [
    { value: '0', label: 'Dimanche' },
    { value: '1', label: 'Lundi' },
    { value: '2', label: 'Mardi' },
    { value: '3', label: 'Mercredi' },
    { value: '4', label: 'Jeudi' },
    { value: '5', label: 'Vendredi' },
    { value: '6', label: 'Samedi' }
  ];

  useEffect(() => {
    loadConfig();
  }, []);

  const loadConfig = async () => {
    try {
      const response = await fetch(`${API_BASE}/configuration`);
      const data = await response.json();
      
      // Transformer le tableau en objet
      const configObj = {};
      data.forEach(item => {
        configObj[item.param_name] = item.param_value;
      });
      
      setConfig(prevConfig => ({
        ...prevConfig,
        ...configObj
      }));
      
      setLoading(false);
    } catch (error) {
      console.error('Erreur chargement config:', error);
      setLoading(false);
    }
  };

  const handleChange = (paramName, value) => {
    setConfig(prev => ({
      ...prev,
      [paramName]: value
    }));
  };

  const handleSave = async () => {
    setSaving(true);
    
    try {
      // Sauvegarder chaque paramètre
      const promises = Object.entries(config).map(([paramName, paramValue]) => {
        return fetch(`${API_BASE}/configuration/${paramName}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ param_value: paramValue })
        });
      });
      
      await Promise.all(promises);
      
      alert('✅ Paramètres enregistrés avec succès !');
      setSaving(false);
    } catch (error) {
      console.error('Erreur sauvegarde:', error);
      alert('❌ Erreur lors de la sauvegarde');
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-8">
        <div className="text-gray-500">Chargement des paramètres...</div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* En-tête */}
      <div className="bg-gradient-to-r from-green-600 to-green-500 rounded-lg p-6 text-white">
        <h2 className="text-2xl font-bold mb-2">📅 Planning Hebdomadaire</h2>
        <p className="text-green-100">
          Configuration des horaires d'ouverture et de fermeture des réservations
        </p>
      </div>

      {/* Fenêtre de réservation */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
          <span className="text-2xl mr-2">🕐</span>
          Fenêtre de Réservation
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Ouverture nouvelles réservations */}
          <div className="space-y-4">
            <h4 className="font-medium text-gray-700">Ouverture Nouvelles Réservations</h4>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Jour</label>
              <select
                value={config.jour_ouverture_resa}
                onChange={(e) => handleChange('jour_ouverture_resa', e.target.value)}
                className="w-full p-2 border rounded-md focus:ring-green-500 focus:border-green-500"
              >
                {joursOptions.map(jour => (
                  <option key={jour.value} value={jour.value}>{jour.label}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Heure</label>
              <input
                type="time"
                value={config.heure_ouverture_resa}
                onChange={(e) => handleChange('heure_ouverture_resa', e.target.value)}
                className="w-full p-2 border rounded-md focus:ring-green-500 focus:border-green-500"
              />
            </div>
          </div>

          {/* Fermeture nouvelles réservations */}
          <div className="space-y-4">
            <h4 className="font-medium text-gray-700">Fermeture Nouvelles Réservations</h4>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Jour</label>
              <select
                value={config.jour_fermeture_nouvelle_resa}
                onChange={(e) => handleChange('jour_fermeture_nouvelle_resa', e.target.value)}
                className="w-full p-2 border rounded-md focus:ring-green-500 focus:border-green-500"
              >
                {joursOptions.map(jour => (
                  <option key={jour.value} value={jour.value}>{jour.label}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Heure</label>
              <input
                type="time"
                value={config.heure_fermeture_nouvelle_resa}
                onChange={(e) => handleChange('heure_fermeture_nouvelle_resa', e.target.value)}
                className="w-full p-2 border rounded-md focus:ring-green-500 focus:border-green-500"
              />
            </div>
          </div>
        </div>

        {/* Fermeture modifications */}
        <div className="mt-6 p-4 bg-yellow-50 border-l-4 border-yellow-400 rounded">
          <h4 className="font-medium text-yellow-900 mb-3">Fermeture des Modifications</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-yellow-800 mb-2">Jour</label>
              <select
                value={config.jour_fermeture_modif_resa}
                onChange={(e) => handleChange('jour_fermeture_modif_resa', e.target.value)}
                className="w-full p-2 border rounded-md"
              >
                {joursOptions.map(jour => (
                  <option key={jour.value} value={jour.value}>{jour.label}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-yellow-800 mb-2">Heure</label>
              <input
                type="time"
                value={config.heure_fermeture_modif_resa}
                onChange={(e) => handleChange('heure_fermeture_modif_resa', e.target.value)}
                className="w-full p-2 border rounded-md"
              />
            </div>
          </div>
          <p className="text-sm text-yellow-700 mt-3">
            ⚠️ Les clients peuvent modifier leurs réservations existantes jusqu'à cette date/heure
          </p>
        </div>
      </div>

      {/* Option Mercredi */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
          <span className="text-2xl mr-2">🏪</span>
          Vente Directe Mercredi (Optionnel)
        </h3>
        
        <div className="mb-4">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={config.mercredi_vente_directe_actif === 'oui'}
              onChange={(e) => handleChange('mercredi_vente_directe_actif', e.target.checked ? 'oui' : 'non')}
              className="mr-2"
            />
            <span className="text-sm text-gray-700">Activer la vente directe le mercredi</span>
          </label>
        </div>

        {config.mercredi_vente_directe_actif === 'oui' && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
            <div>
              <h4 className="font-medium text-gray-700 mb-3">Horaires Matin</h4>
              <div className="space-y-2">
                <div>
                  <label className="block text-sm text-gray-600">Ouverture</label>
                  <input
                    type="time"
                    value={config.mercredi_heure_ouverture_matin}
                    onChange={(e) => handleChange('mercredi_heure_ouverture_matin', e.target.value)}
                    className="w-full p-2 border rounded-md"
                  />
                </div>
                <div>
                  <label className="block text-sm text-gray-600">Fermeture</label>
                  <input
                    type="time"
                    value={config.mercredi_heure_fermeture_matin}
                    onChange={(e) => handleChange('mercredi_heure_fermeture_matin', e.target.value)}
                    className="w-full p-2 border rounded-md"
                  />
                </div>
              </div>
            </div>
            
            <div>
              <h4 className="font-medium text-gray-700 mb-3">Horaires Après-midi</h4>
              <div className="space-y-2">
                <div>
                  <label className="block text-sm text-gray-600">Ouverture</label>
                  <input
                    type="time"
                    value={config.mercredi_heure_ouverture_aprem}
                    onChange={(e) => handleChange('mercredi_heure_ouverture_aprem', e.target.value)}
                    className="w-full p-2 border rounded-md"
                  />
                </div>
                <div>
                  <label className="block text-sm text-gray-600">Fermeture</label>
                  <input
                    type="time"
                    value={config.mercredi_heure_fermeture_aprem}
                    onChange={(e) => handleChange('mercredi_heure_fermeture_aprem', e.target.value)}
                    className="w-full p-2 border rounded-md"
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Horaires retrait samedi */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
          <span className="text-2xl mr-2">📦</span>
          Horaires Retrait Samedi
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <h4 className="font-medium text-gray-700 mb-3">Horaires Matin</h4>
            <div className="space-y-2">
              <div>
                <label className="block text-sm text-gray-600">Ouverture</label>
                <input
                  type="time"
                  value={config.samedi_heure_ouverture_matin}
                  onChange={(e) => handleChange('samedi_heure_ouverture_matin', e.target.value)}
                  className="w-full p-2 border rounded-md"
                />
              </div>
              <div>
                <label className="block text-sm text-gray-600">Fermeture</label>
                <input
                  type="time"
                  value={config.samedi_heure_fermeture_matin}
                  onChange={(e) => handleChange('samedi_heure_fermeture_matin', e.target.value)}
                  className="w-full p-2 border rounded-md"
                />
              </div>
            </div>
          </div>
          
          <div>
            <h4 className="font-medium text-gray-700 mb-3">Horaires Après-midi</h4>
            <div className="space-y-2">
              <div>
                <label className="block text-sm text-gray-600">Ouverture</label>
                <input
                  type="time"
                  value={config.samedi_heure_ouverture_aprem}
                  onChange={(e) => handleChange('samedi_heure_ouverture_aprem', e.target.value)}
                  className="w-full p-2 border rounded-md"
                />
              </div>
              <div>
                <label className="block text-sm text-gray-600">Fermeture</label>
                <input
                  type="time"
                  value={config.samedi_heure_fermeture_aprem}
                  onChange={(e) => handleChange('samedi_heure_fermeture_aprem', e.target.value)}
                  className="w-full p-2 border rounded-md"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Gestion commandes non retirées */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
          <span className="text-2xl mr-2">🔔</span>
          Gestion Commandes Non Retirées
        </h3>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Délai avant rappel (en heures)
            </label>
            <input
              type="number"
              value={config.delai_rappel_non_retiree}
              onChange={(e) => handleChange('delai_rappel_non_retiree', e.target.value)}
              className="w-full md:w-48 p-2 border rounded-md"
              min="1"
              max="72"
            />
            <p className="text-sm text-gray-500 mt-1">
              Ex: 24h = Rappel le dimanche si non retiré samedi
            </p>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Action automatique
            </label>
            <div className="space-y-2">
              <label className="flex items-center">
                <input
                  type="radio"
                  value="rappel"
                  checked={config.action_non_retiree === 'rappel'}
                  onChange={(e) => handleChange('action_non_retiree', e.target.value)}
                  className="mr-2"
                />
                <span className="text-sm text-gray-700">
                  Email rappel + possibilité report semaine suivante
                </span>
              </label>
              <label className="flex items-center">
                <input
                  type="radio"
                  value="annulation_auto"
                  checked={config.action_non_retiree === 'annulation_auto'}
                  onChange={(e) => handleChange('action_non_retiree', e.target.value)}
                  className="mr-2"
                />
                <span className="text-sm text-gray-700">
                  Annulation automatique + libération stock
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* Bouton Sauvegarder */}
      <div className="flex justify-end">
        <button
          onClick={handleSave}
          disabled={saving}
          className={`px-6 py-3 rounded-lg font-medium text-white ${
            saving
              ? 'bg-gray-400 cursor-not-allowed'
              : 'bg-green-600 hover:bg-green-700'
          }`}
        >
          {saving ? '💾 Enregistrement...' : '💾 Enregistrer les Paramètres'}
        </button>
      </div>
    </div>
  );
};

export default ParametresPlanning;